import HttpClient, {API_BASE_URL} from "./config";
import {Path} from "./Path";
import {CommonUtils} from "../ultilities";

class WeddingService {
    static getUserNameByUserId = (userId) => {

        let url = API_BASE_URL+Path.getUserName;
        url = url.replace("{key}", userId);
        const headers = {
            clientMessageId: CommonUtils.generateUUID()
        }

        return HttpClient.get(url, {
            headers:headers,
            params: {
                userId
            },

        });
    }

    static getAllWish = () => {
        let url = API_BASE_URL+Path.getAllWish;
        url = url.replace("{unit}","wedding");
        const headers = {
            clientMessageId: CommonUtils.generateUUID()
        }

        return HttpClient.get(url, {
            headers
        })
    }

    static saveWish = (payload) => {
        const url = API_BASE_URL+Path.saveWish;
        const headers = {
            clientMessageId: CommonUtils.generateUUID()
        }

        return HttpClient.post(url, payload, {
            headers
        })
    }
}

export default WeddingService;

